<script>
    import AddLoan from './AddLoan.svelte'
    import Loans from './Loans.svelte'
    import Calculator from './Calculator.svelte'

    import { loans } from './stores.js';

    let storedLoans = JSON.parse(localStorage.getItem('loans') || '[]');
    loans.set(storedLoans);

</script>

<main>
    <section class="section">
        <div class="container">
            {#if $loans.length }
            <Calculator />
            <Loans />
            {:else}
            <h1 class="title is-1">Actual Money</h1>
            <h4 class="subtitle is-4">See how much something actually costs when you have outstanding debt</h4>
            <p>Add in your highest value loan and save this page to your homescreen.</p>
            <p>Next time you're thinking of spending some money, enter the amount to see how much it will actually cost you.</p>
            <AddLoan />
            {/if}
        </div>
    </section>
</main>

<style>
</style>
